import EFVideoModal, { PlayerType } from '@/components/UI/EFVideoModal';
import Image from '@/components/UI/Image';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { ReactNode, useEffect, useState } from 'react';
import css from './index.module.scss';
const { EFPic } = createEFPic('/img/landingPage/h5/');
const imgMap: any = {
    us: ['KV.webp', 'KV.jpg'],
    ca: ['KV_ca.jpg', 'KV_ca.jpg'],
    sa: ['KV_me-ar.webp', 'KV_me-ar.jpg'],
    za: ['KV_me-ar.webp', 'KV_me-ar.jpg'],
};
const VIDEO_SOURCE: any = {
    us: 'https://www.youtube.com/embed/lpIFKQ5HlH8',
    sa: 'https://www.youtube.com/embed/cHSA9zIk0cU',
    za: 'https://www.youtube.com/embed/R3cUJ1g-QTI?si=ZRva0v7YIq2vxNjr',
    au: 'https://www.youtube.com/embed/R3cUJ1g-QTI?si=aKu_XLEu-dWmEr_S',
};

export default function Bannervideo() {
    const { useRouter, useLang, gtm } = useGlobal();
    const { t } = useLang('landingPage');
    const [isEnter, setIsEnter] = useState(false);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const { locale } = useRouter();

    useEffect(() => {
        setIsEnter(true);
    }, []);

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'Whole-Home Backup Power Solution - Power Has Never Been This Easy',
            position,
        });
        setShowEFVideoModal(true);
    };

    return (
        <div className={`${css.bannervideo} bannervideo`}>
            <div className={`bannerBox page-video ${isEnter ? 'isEnter' : ''}`}>
                <div className="discount-tip">
                    <div className="coupon-icon">
                        <Image src="/img/landingPage/h5/icon/coupon.png" noUseSrcset layout="fill" className="fullImgs" alt={t('Watch video')} />
                    </div>
                    <div className="tip-text">
                        {t.rich('delta_pro_whole_home.discount_tip', {
                            line1: (child: ReactNode) => <span className="">{child} </span>,
                            line2: (child: ReactNode) => <span style={{ fontWeight: 'bolder' }}>{child} </span>,
                            line3: (child: ReactNode) => <span>{child} </span>,
                        })}
                    </div>
                </div>
                <div className="videxBox">
                    <EFPic name={imgMap[locale] || imgMap.us} alt={'kv'} />
                </div>
                <div className="bannerText">
                    <h1 className="bannerMsg1">
                        {t.rich('delta_pro_whole_home.page1_msg1', {
                            line1: (child: ReactNode) => <div>{child} </div>,
                            line2: (child: ReactNode) => <div>{child} </div>,
                        })}
                    </h1>
                    <div className="bannerMsg2">{t('delta_pro_whole_home.page1_msg2')}</div>
                </div>
                <div className="videoButton" onClick={() => playerVideo(t('delta_pro_whole_home.page1_msg1'))}>
                    <div className="btnText font-family-medium">{t('delta_pro_whole_home.watch_video')}</div>
                    <div className="btn-icon">
                        <Image src="/img/landingPage/h5/icon/play.png" noUseSrcset layout="fill" className="fullImgs" alt={t('Watch video')} />
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={VIDEO_SOURCE[locale] || VIDEO_SOURCE.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? PlayerType.Alibaba : PlayerType.YouTube}
            />
        </div>
    );
}
